/**
 * Wheel of Fortune letterboard display component.
 */
angular.module('tgaAdmin').component('wofLetterboard', {
  controller: [
    '$scope',
    '$element',
    '$document',
    function WofLetterboardController(scope, element, $document) {
      // Get a reference to window.document
      const realDoc = $document[0];

      /**
       * Generate an SVG in the directive's container.
       */
      this.makeBoardTiles = () => {
        if (this.tileContainer == null) {
          return null;
        }

        const svg = realDoc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const svgNS = svg.namespaceURI;

        const numRows = 4;
        const numCols = 14;
        const tileHeight = 34;
        const tileWidth = 25;
        const strokeWidth = 4;
        const marginSize = 2;

        const viewBoxWidth = numCols * (tileWidth + strokeWidth + marginSize);
        const viewBoxHeight = numRows * (tileHeight + strokeWidth + marginSize);
        svg.setAttribute('viewBox', `0 0 ${viewBoxWidth} ${viewBoxHeight}`);
        svg.setAttribute('class', 'letterboard-svg');

        for (let y = 0; y < numRows; y++) {
          for (let x = 0; x < numCols; x++) {
            if (
              !(y === 0 && x === 0)
              && !(y === 0 && x === 13)
              && !(y === 3 && x === 0)
              && !(y === 3 && x === 13)
            ) {
              const group = realDoc.createElementNS(svgNS, 'g');
              const image = realDoc.createElementNS(svgNS, 'image');
              const rect = realDoc.createElementNS(svgNS, 'rect');
              const text = realDoc.createElementNS(svgNS, 'text');

              group.setAttribute('class', 'tile default');
              group.setAttribute('tile', `${y}_${x}`);
              const xOffset = x * (tileWidth + strokeWidth + marginSize);
              const yOffset = y * (tileHeight + strokeWidth + marginSize);
              group.setAttribute('transform', `translate(${xOffset}, ${yOffset})`);

              image.setAttribute('width', tileWidth);
              image.setAttribute('x', marginSize);
              image.setAttribute('height', tileHeight);
              image.setAttribute('y', marginSize);
              image.setAttribute('href', './v1/assets/images/wof/tile-default.svg');
              image.setAttribute('class', 'letter-tile-svg');

              rect.setAttribute('width', tileWidth);
              rect.setAttribute('x', marginSize);
              rect.setAttribute('height', tileHeight);
              rect.setAttribute('y', marginSize);
              rect.setAttribute('stroke-width', strokeWidth);
              rect.setAttribute('class', 'letter-tile-svg');

              text.setAttribute('x', (tileWidth + strokeWidth) / 2);
              text.setAttribute('text-anchor', 'middle');
              text.setAttribute('y', (tileHeight + strokeWidth) / 2);
              text.setAttribute('dominant-baseline', 'central');
              text.setAttribute('class', 'letter-text-svg');
              text.textContent = '';

              group.appendChild(image);
              group.appendChild(rect);
              group.appendChild(text);
              svg.appendChild(group);
            }
          }
        }

        this.tileContainer.append(svg);
        return svg;
      };

      /**
       * Updates the SVG board tiles
       */
      // eslint-disable-next-line consistent-return
      this.updateBoard = () => {
        if (this.tileContainer == null) {
          return null;
        }

        // Reset board
        this.tileContainer.find('.tile')
          .removeClass(['letter', 'dragging']).addClass('default').find('.letter-text-svg')
          .text('');

        // load board tiles
        _.forEach(this.tiles, ({
          row, col, letter, specialChar,
        }) => {
          const classes = ['letter'];
          // highlight if it's in the list of bonus preset letters
          if (this.puzzleType === 'wof_bonus' && _.find(this.bonusSet, ['letter', letter])) {
            classes.push('dragging');
          }
          // add specialChar class if it is a special character (doesn't disappear during tossup preview)
          if (specialChar) {
            classes.push('specialChar');
          }
          this.tileContainer
            .find(`.tile[tile='${row}_${col}']`)
            .removeClass('default')
            .addClass(classes)
            .find('.letter-text-svg')
            .text(letter);
        });
      };

      this.$onChanges = (changesObj) => {
        if (changesObj.tiles || changesObj.bonusSet) {
          this.updateBoard();
        }
      };

      this.$onInit = () => {
        this.tileContainer = element.find('.letterboard-svg-container');
        this.makeBoardTiles();
        this.updateBoard();
      };
    },
  ],
  template: '<div class="letterboard-svg-container"></div>',
  bindings: {
    tiles: '<*',
    puzzleType: '<',
    bonusSet: '<*',
  },
});
